<template>
    <div class='GiveUp'>
        <ApplyNoalert ref='ApplyNoalert'/>
        <el-form :inline="true" :model="formInline" class="demo-form-inline selectForm">
            <el-form-item label="政策名称：">
                <el-input v-model="formInline.user" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="申请时间：">
                <el-date-picker
                style="width:250px"
                v-model="value1"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table
            height="520"
            class="applyTable"
            ref="multipleTable"
            :data="tableDataAll"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="num" label="序号" align="center" width="60"></el-table-column>
            <el-table-column prop="name" label="政策名称" align="center"></el-table-column>
            <el-table-column prop="money" label="金额" align="center"></el-table-column>
            <el-table-column prop="statu" label="状态/意见" align="center">
                <template slot-scope="scope">
                    <span class="statuColor applying" v-if="scope.row.statu==1">审核中</span>
                    <span class="statuColor applypass" v-if="scope.row.statu==2">审核通过</span>
                    <span class="statuColor applyreject" v-if="scope.row.statu==3">
                        已驳回
                        <i class="el-icon-question rejectIcon" :title="scope.row.statuReason"></i>
                    </span>
                    <span class="statuColor uploaddata" v-if="scope.row.statu==4">待上传数据</span>
                    <span class="statuColor tocash" v-if="scope.row.statu==5">已兑现</span>
                    <span class="statuColor givrup" v-if="scope.row.statu==6">已放弃</span>
                </template>
            </el-table-column>
            <el-table-column prop="time" label="申请时间" align="center"></el-table-column>
            <el-table-column label="操作" align="center" width="355">
            <template slot-scope="scope">
                 <!-- 1.审核中 2.审核通过 3.已驳回 4.待上传数据 5.已兑现 6.已放弃 -->
          <el-button  size="mini" @click="look(scope.$index, scope.row)"
            >查看</el-button
          >
          <el-button size="mini" v-if="scope.row.statu==3" @click="appeal(scope.$index, scope.row)"
            >申诉</el-button
          >
          <el-button size="mini" v-if="scope.row.statu==4" @click="upload(scope.$index, scope.row)"
            >上传收据</el-button
          >
          <el-button size="mini" v-if="scope.row.statu==5" @click="download(scope.$index, scope.row)"
            >下载收据</el-button
          >
            </template>
            </el-table-column>
        </el-table>
        <div class="applyPagination">
            <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="2">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import ApplyNoalert from '@/components/ApplyNo_alert.vue'
    export default {
        name: "GiveUp",
        components:{
            ApplyNoalert
        },
        data() {
            return {
                formInline: {
                    user: '',
                    region: ''
                },
                value1: '',
                currentPage: 1,
               tableDataAll:[{
                        num: '1',
                        name: '工业设计中心认定奖励',
                        money: '873,000元',
                        statu: 6,
                        statuReason:"",
                        time: '2022-01-19',
                    },{
                        num: '2',
                        name: '工业设计中心认定奖励',
                        money: '873,000元',
                        statu: 6,
                        statuReason:"",
                        time: '2021-02-27',
                    }
                ],
            };
        },
        methods: {
            onSubmit(){
                
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            look() {
                this.$router.push({
                    name: "ApplyNo_det",
                });
            },
            appeal() {
                this.$refs.ApplyNoalert.show({
                    type:1
                })
            },
            upload() {
                this.$refs.ApplyNoalert.show({
                    type:2
                })
            },
            download(){

            },
            // 分页
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
            }
        }
    };
</script>
<style lang='scss' scoped>
.GiveUp{
    .applyTab{
        border-top: 2px solid #E4E7ED;
        /deep/.el-tabs__item{
            padding: 0 20px;
            font-size: 16px;
            height: 50px;
            line-height: 50px;
            color: rgba(56, 56, 56, 1);
        }
        /deep/.selectForm{
            .el-form-item{
                margin-right: 5%;
            }
            .el-date-editor .el-range-separator{
                width: 10%;
            }
        }
    } 
    .applyTable{
        /deep/.has-gutter tr th{
            background-color: rgba(250, 250, 250, 1);
        }
        .statuColor::before{
            content: "";
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            margin-right: 5px;
        }
        .applying::before{
            background-color:rgba(24, 144, 255, 1);
        }
        .applypass::before{
            background-color:rgba(67, 207, 124, 1);
        }
        .applyreject::before{
            background-color:rgba(245, 34, 45, 1);
        }
        .uploaddata::before{
            background-color:rgb(25, 207, 231);
        }
        .tocash::before{
            background-color:rgba(255, 141, 26, 1);
        }
        .givrup::before{
            background-color:rgba(0, 0, 0, 0.25);
        }
    }
    .applyPagination{
        text-align: right;
        margin-top: 10px;
    }
}

</style>